import { cn } from '../lib/utils.js';

// "Link in bio" channel badges — the platforms a proptree link is
// confirmed to live on, detected from per-channel organic page loads.
// Shared by the proptrees and affiliate lists.
//
// Brand logo assets are copied from the landing page's /landing/social
// set (same icons the marketing demo shows). Channels without an asset
// fall back to a colored first-letter circle.
const BIO_CHANNEL_ICONS: Record<string, string> = {
  facebook: '/social/facebook.png',
  instagram: '/social/instagram.png',
  linkedin: '/social/linkedin.png',
  meta: '/social/meta.png',
  snapchat: '/social/snapchat.png',
  tiktok: '/social/tiktok.png',
  whatsapp: '/social/whatsapp.png',
};

const BIO_CHANNEL_COLORS: Record<string, string> = {
  facebook: '#1877F2',
  instagram: '#E1306C',
  meta: '#1877F2',
  whatsapp: '#25D366',
  linkedin: '#0A66C2',
  tiktok: '#000000',
  snapchat: '#FFFC00',
  youtube: '#FF0000',
  x: '#000000',
  telegram: '#0088CC',
  wechat: '#07C160',
  pinterest: '#E60023',
  medium: '#000000',
  tumblr: '#001935',
};

// null = no data at all ("—"); [] = link not detected anywhere yet.
export function BioChannelsCell({ channels }: { channels: string[] | null }) {
  if (channels === null) {
    return (
      <span className="font-sans text-[13px] font-medium text-muted-foreground">
        —
      </span>
    );
  }
  if (channels.length === 0) {
    return (
      <span className="inline-flex items-center whitespace-nowrap rounded-md bg-muted px-2 py-0.5 font-sans text-[12px] font-medium text-foreground">
        Unconfirmed
      </span>
    );
  }
  return (
    <div className="flex items-center">
      {channels.map((ch, i) => {
        const icon = BIO_CHANNEL_ICONS[ch];
        if (icon) {
          return (
            <span
              key={ch}
              title={ch}
              className={cn(
                'flex h-6 w-6 items-center justify-center rounded-full border border-black/5 bg-white ring-2 ring-card',
                i > 0 && '-ml-1.5',
              )}
            >
              <img src={icon} alt={ch} className="h-3.5 w-3.5 object-contain" />
            </span>
          );
        }
        const bg = BIO_CHANNEL_COLORS[ch] ?? '#6B7280';
        const isLightBg = ch === 'snapchat';
        return (
          <span
            key={ch}
            title={ch}
            style={{ backgroundColor: bg }}
            className={cn(
              'flex h-6 w-6 items-center justify-center rounded-full font-sans text-[11px] font-bold uppercase ring-2 ring-card',
              isLightBg ? 'text-foreground' : 'text-white',
              i > 0 && '-ml-1.5',
            )}
          >
            {ch.charAt(0)}
          </span>
        );
      })}
    </div>
  );
}
